module.exports = __webpack_public_path__ + "img/紫荆花漆.d4e8de9d.png";